import {Product} from "@app/core/product/domain/dtos/product";

/**
 * Represents an error when a stock check fails due to insufficient stock for certain products.
 */
export class NoStockError {
    noStockProducts: Product[] = []

    constructor(products: Product[]) {
        this.noStockProducts = products;
        return this;
    }
}
